import React from 'react';
import Media from '../media';
import { IMG_BASE_PATH } from 'utils/constants';

const HeroBanner = () => {
  return (
    <>
      <div className='si-heroBanner'>
        <Media imgSrc={`${IMG_BASE_PATH}images/hero-logo.svg`} imgAlt='banner' />
      </div>
    </>
  );
};

export default HeroBanner;
